var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navigation',{attrs:{"drawer":_vm.drawerApp},on:{"toggleDrawer":function($event){_vm.drawerApp = $event}}}),_c('nb-supervisor-toolbar',{attrs:{"is-lang-switcher":false,"color":"red darken-4"},on:{"toggleDrawer":function($event){_vm.drawerApp = !_vm.drawerApp}}}),_c('v-content',[_c('router-view')],1),_c('snack-displayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }